import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

export const DatosEditablesSKIM =
{
    InventarioInicial: { rowName: 'Inventario Inicial', ...DefaultMonthsColumns },
    DelMes: { rowName: '(+) Del mes', ...DefaultMonthsColumns },
    AjusteDelMes: { rowName: '(-) Ajuste del mes', ...DefaultMonthsColumns, isNegative: true },
    MermaPorProceso: { rowName: '(-) Merma por proceso', ...DefaultMonthsColumns, isNegative: true },
}

export const TotalesSKIM =
{
    // CtoPromedioDelInven: { rowName: 'Cto. Promedio del Inven.', ...DefaultMonthsColumns },
    SalidasAProduccion: { rowName: 'Salidas a producción', ...DefaultMonthsColumns },
    // InventarioFinal: { rowName: 'Inventario Final', ...DefaultMonthsColumns },
}

export const SKIMData = {
    ...DatosEditablesSKIM,
    ...TotalesSKIM
}

export const EditableRowNames = Object.keys(DatosEditablesSKIM);

export const TotalRowNames = [
    'Cto. Promedio del Inven.',
    'Salidas a producción',
    'Inventario Final'
]
